/*
saikrishna 10/06/2022 3075154998 Removed unecesarry console.log statements
dilip 10/11/2022 3075154998  Data Manager Matching logic changes
Suresh Peddavoora 10/26/2022 3075154998  Changed Text Field Variant from outlined to standard
Akhila  10/28/2022 3075154998 data manager ux changes
Suresh Peddavoora 10/31/2022 3075154998  Added card styles for table header
Raghu Arun Kumar 11/02/2022 3075154998  Responsive Alignment Fixes
Lalitha  11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useContext, useState} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, FormControl, Button} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {RECORD_TYPE} from '../../../../../constants/Lookup';
import FilterTable from './FilterTable';
import {useSelector, useDispatch} from 'react-redux';
import {
  postFilterGroup,
} from '../../../../../redux/reducers/DMFilterGroup';
import {useEffect} from 'react';
import {FormHelperText} from '@material-ui/core';
import {getOptions} from './../../../../../util/GetDropDownOptions';
import {Typography} from '@material-ui/core';
import {getObject} from './../../../../../util/GetDropdownObject';
import PageLoader from './../../../../../components/PageLoader/index';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {makeStyles} from '@material-ui/core/styles';
import FiltersSystemNotes from './FilterGroupSystemNotes';
import {yupResolver} from '@hookform/resolvers/yup';
import AddIcon from '@material-ui/icons/Add';
import * as Yup from 'yup';
import DialogBox from './../../../../../components/DialogBox/index';
import AddFilter from './AddFilterGroup';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0 0',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));
export default function AddTrigger({setValue}) {
  const classes1 = useStyles();
  const [expanded, setExpanded] = useState();
  const [disabled, setDisabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [rowData, setRowData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const {dropDownData} = useSelector(({filter}) => filter);
  const {
    filterGroupData,
    isLoading,
    errorMsg,
    successMsg,
    filterGroupCodeData,
  } = useSelector(({dMFilterGroup}) => dMFilterGroup);
  const {reusableInputStyles} = useContext(ThemeContext);
  const dispatch = useDispatch();

  const classes = reusableInputStyles();
  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const checkEmailExist = (value) => {
    if (filterGroupCodeData && filterGroupCodeData?.length > 0 && value) {
      const ar = [];
      filterGroupCodeData.filter((i) => {
        if (i?.filterGroupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const validationSchema = Yup.object().shape({
    code:
      filterGroupData && filterGroupData?.filterGroupCode ?
        Yup.string().required('Code is required') :
        Yup.string()
          .required('Code is required')
          .test('recordType', 'Code already exist', (value) => !checkEmailExist(value)),
    description: Yup.string().required('Description is required'),
    recordType: Yup.mixed().test('recordType', 'Record Type is required', (value) => {
      if (!value?.valueCode) {
        return false;
      } else {
        return true;
      }
    }),
  });
  const initialValues = {
    code:
      filterGroupData && filterGroupData?.filterGroupCode ? filterGroupData?.filterGroupCode : '',
    description:
      filterGroupData && filterGroupData?.description ? filterGroupData?.description : '',
    recordType:
      filterGroupData && filterGroupData?.recordType ?
        getObject(filterGroupData?.recordType, RECORD_TYPE, dropDownData) :
        null,
  };
  const {handleSubmit, control, reset, errors} = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    reset(initialValues);
  }, [filterGroupData]);
  const onSubmit = (data) => {
    setDisabled(true);
    if (data) {
      dispatch(
        postFilterGroup({
          dMFilterGroupMapRequest: [
            // {
            //   filterCode: "Code",
            //   filterMapId: 0,
            //   seqNum: 0,
            //   translationTable: "table",
            // },
          ],
          deleteTaskIds: [0],
          description: data?.description || '',
          filterGroupCode: data?.code?.toUpperCase() || '',
          filterGroupId: filterGroupData?.filterGroupCode || 0,
          recordType: data?.recordType?.valueCode || null,
        }),
      );
    }
  };
  // useEffect(() => {
  //   dispatch(getDropDownData());
  //   dispatch(fetchFilterGroupCode());
  // }, []);
  // useEffect(() => {
  //   if (successMsg || errorMsg) {
  //     setTimeout(() => {
  //       dispatch(resetMessage());
  //     }, 2500);
  //   }
  // }, [successMsg, errorMsg]);
  // useEffect(() => {
  //   if (errorMsg) {
  //     setDisabled(false);
  //   }
  // }, [errorMsg]);
  // useEffect(() => {
  //   if (addFilterGroupStatus === 200) {
  //     setTimeout(() => {
  //       dispatch(resetMessage());

  //       setValue(0);
  //     }, 2500);
  //   }
  // }, [addFilterGroupStatus]);
  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          disabled={isLoading || successMsg}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            setValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
                    Search Filter Group
        </Button>
      </div>
      <div className={`mb-0`}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-row align-items-center global-field-textfields">
            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={`${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Code"
                      margin="dense"
                      name="code"
                      variant="outlined"
                      label="Code"
                      value={value?.toUpperCase()}
                      disabled={Boolean(filterGroupData && filterGroupData?.filterGroupCode)}
                      onChange={onChange}
                      error={Boolean(errors.code?.message)}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="code"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.code?.message ? errors.code.message : ''}
              </FormHelperText>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={`${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Description"
                      margin="dense"
                      name="description"
                      variant="outlined"
                      label="Description"
                      value={value}
                      onChange={onChange}
                      error={Boolean(errors?.description?.message)}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="description"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.description?.message ? errors.description.message : ''}
              </FormHelperText>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="recordType"
                      options={getOptions(RECORD_TYPE, dropDownData)}
                      size="small"
                      autoHighlight
                      getOptionDisabled={(option) => option.valueCode === 'none'}
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            option.value ?
                              option.value :
                              '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName} ${classes.selectLabel}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Record Type"
                          name="recordType"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={Boolean(errors?.recordType?.message)}
                          placeholder="Select Record Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="recordType"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.recordType?.message ? errors.recordType?.message : ''}
              </FormHelperText>
            </div>
          </div>
          <div className={` border-rounded mb-0`}>
            <div className="table-header table-card-header d-flex justify-content-between">
              <Typography variant="h4">Filters</Typography>
              <Button
                variant="outlined"
                className={`search-btn ${classes.buttonRoot}`}
                onClick={() => setOpen(true)}
              >
                <AddIcon />
                Add Filter
              </Button>
            </div>
            <FilterTable filterData={filterData} setOpen={setOpen} setRowData={setRowData} setIsEdit={setIsEdit}/>
          </div>

          <div className="row justify-content-center mt-4 mb-2">
            <Button
              type="button"
              onClick={() => reset(initialValues)}
              variant="outlined"
              className={`reset-btn mx-1 ${classes.buttonRoot}`}
            >
              Reset
            </Button>
            <Button
              type="submit"
              variant="outlined"
              className={`search-btn mx-1 ${classes.buttonRoot}`}
              disabled={disabled}
            >
              Save
            </Button>
          </div>
        </form>
        {filterGroupData?.filterGroupCode && (
          <div className={`${classes1.root} mt-3`}>
            <Accordion
              className="accordion-styling"
              expanded={expanded === 'panel1'}
              onChange={handleAccordionChange('panel1')}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={classes1.heading}>
                  Filter Group Notes
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <FiltersSystemNotes filterGroupCode={filterGroupData?.filterGroupCode} />
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </div>
      <DialogBox open={open} dialogClose={handleClose} title="Add Filter" maxWidth="md">
        <AddFilter
          setFilterData={setFilterData}
          filterData={filterData}
          setOpen={setOpen}
          rowData={rowData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      </DialogBox>
      {isLoading && <PageLoader />}

      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}
